import { extractPage, searchPageParams } from "../springdata";
import { asFormData } from "@/services/requete/RequeteService";

export default class AssociationService{
    constructor(axios, snackbar) {
        this.axios = axios;
        this.snackbar = snackbar;
    }

    listeAssociations(search, pagination, signal) {
        return this.axios
            .get("/api/association", { params: searchPageParams(search, pagination), signal })
            .then(response => extractPage(response.data));
    }

    chargeFicheAssociation(numero) {
        return this.axios
            .get(`/api/association/${numero}`)
            .then(response => response.data);
    }

    extrait(id, params) {
        return this.axios
            .get(`/api/association/${id}/extrait`, {
                responseType: "blob",
                params,
            })
            .catch(this.snackbar.catch())
            .then(response => response.data);
    }

    valideInvitationAssociation(numero, valide) {
        return this.axios
            .put(`/api/association/${numero}/invitation`, { valide })
            .then(response => response.data);
    }

    supprimerInvitation(numero, tache) {
        return this.axios
            .delete(`/api/association/${numero}/invitation/${tache}`)
            .then(response => response.data);
    }

    reenvoiInvitation(numero, tache) {
        return this.axios
            .post(`/api/association/${numero}/invitation/${tache}/reenvoi`)
            .then(response => response.data);
    }

    invitationUsager(numero, email, fonction, gestion, depot) {
        return this.axios
            .post(`/api/association/${numero}/invitation`, { email, fonction, gestion, depot })
            .then(response => response.data);
    }

    modificationUsager(numero, email, fonction, gestion, depot) {
        return this.axios
            .put(`/api/association/${numero}/rattachement`, { email, fonction, gestion, depot })
            .then(response => response.data);
    }

    supprimerUsager(numero, sujet, commentaire) {
        return this.axios
            .post(`/api/association/${numero}/rattachement/${sujet}/delete`, {commentaire})
            .then(response => response.data);
    }



    demandeNumerisation(numero) {
        return this.axios
            .post(`/api/association/${numero}/numerisation`)
            .then(response => response.data);
    }

    demandeRattachement( numero, infos, annexes) {
        const rattachement = {
          ...infos,
            documents: annexes.map(a => ({ type: a.type })),
        }

        const fichiers = annexes.map(a => a.fichier);
        return asFormData(rattachement, fichiers, { document: "rattachement" }).catch(error => {
            throw error;
        }).then(formData => {
            return this.axios
                .post(`/api/association/${numero}/rattachement`, formData)
                .then(response => response.data);
        });
    }

}
